import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './bojack-search';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<App />);
